/** URL `?tab=` values for client overview. */
export const ClientOverviewTabParam = {
  OVERVIEW: "overview",
  CONTACTS: "contacts",
} as const;

export type ClientOverviewTabParamValue =
  (typeof ClientOverviewTabParam)[keyof typeof ClientOverviewTabParam];

const TAB_ID_TO_PARAM: Record<string, ClientOverviewTabParamValue> = {
  "1": ClientOverviewTabParam.OVERVIEW,
  "2": ClientOverviewTabParam.CONTACTS,
};

const PARAM_TO_TAB_ID: Record<string, string> = {
  [ClientOverviewTabParam.OVERVIEW]: "1",
  [ClientOverviewTabParam.CONTACTS]: "2",
};

export function clientOverviewTabIdFromSearchParam(tab: string | null): string {
  if (!tab) return "1";
  return PARAM_TO_TAB_ID[tab] ?? "1";
}

export function searchParamForClientOverviewTabId(
  tabId: string,
): ClientOverviewTabParamValue | null {
  return TAB_ID_TO_PARAM[tabId] ?? null;
}

export function isValidClientOverviewTabParam(tab: string | null): boolean {
  if (!tab) return false;
  return Object.prototype.hasOwnProperty.call(PARAM_TO_TAB_ID, tab);
}
